/**
 * Function to do an AJAX Request to WordPress
 * @param {JSON} requestData Object with data for AJAX Request
 * @param {Function} responseFunction Function that runs when AJAX request is responded
 * @param {String} actionType String to choose the action to do in HTML wrapperElement: 'append' or 'overwrite'
 * @param {HTMLJQueryElement} wrapperElement Element on which the actionType is performed
 * @param {HTMLElement} loadingElement Element displayed while the AJAX Request is responded
 * @returns {void}
 */

export function AJAX_WP_Query(requestData, responseFunction, actionType, wrapperElement, loadingElement) {
	requestData.action = 'AJAX_WP_Query';

	(function ($) {
		$(document).ready(function ($) {
			$.ajax({
				url: adminAJAX.ajaxurl,
				method: 'POST',
				data: requestData,
				beforeSend: function () {
					switch (actionType) {
						case 'append':
							wrapperElement.append(loadingElement);
							break;
						case 'overwrite':
							wrapperElement.html(loadingElement);
							break;
						default:
							break;
					}
				},
				success: function (res) {
					responseFunction(res);
				},
				error: function (error) {
					console.error(error);
				}
			});
		});
	})(jQuery);
}
